'use strict';

/**
 * Measure user login by using a 'login' actionFieldObject and the login method.
 *
 * @param {Object} loginData An object containing login information.
 * @param {array} dataLayer
 */
function piwikTriggerLoginEvent(loginData, dataLayer) {
    try {
        var data = {
            event: 'login',
            ecommerce: {
                method: loginData.method
            }
        };

        dataLayer.push({ ecommerce: null });
        dataLayer.push(data);
    } catch (e) {
        console.error('Piwik Analytics: Error in piwikTriggerLoginEvent:', e);
    }
}

$(function () {
    piwikTriggerLoginEvent(window.piwikLoginData || {}, window.dataLayer || []);
});
